/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CandidateAcademicProgramCompletion
 */
export interface CandidateAcademicProgramCompletion {
    /**
     * 
     * @type {string}
     * @memberof CandidateAcademicProgramCompletion
     */
    academicProgram?: string;
    /**
     * 
     * @type {number}
     * @memberof CandidateAcademicProgramCompletion
     */
    completion?: number;
}

export function CandidateAcademicProgramCompletionFromJSON(json: any): CandidateAcademicProgramCompletion {
    return CandidateAcademicProgramCompletionFromJSONTyped(json, false);
}

export function CandidateAcademicProgramCompletionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateAcademicProgramCompletion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'academicProgram': !exists(json, 'academic_program') ? undefined : json['academic_program'],
        'completion': !exists(json, 'completion') ? undefined : json['completion'],
    };
}

export function CandidateAcademicProgramCompletionToJSON(value?: CandidateAcademicProgramCompletion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'academic_program': value.academicProgram,
        'completion': value.completion,
    };
}


